import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import EngagementHeader from './selectedengagementtableheader';
import Headerbody from './SelectedHeaderbodystyle';
import styled from 'styled-components';
import {
	labels,
	successMessageDisplayDuration,
	reportFormateType,
	reportType
} from '../../../../util/uiconstants';
import env from '../../../../util/env';
import moment from 'moment';
import Loader from '@ey/loader';
import SelectedEngagementTableRow from './selectedengagementtablerow';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import Toast from '../../../Common/Toast/Toast';
import {setEngagementUpdateSuccessMessage} from '../../../../actions/admin/successmessageactions';
import {downloadReport} from '../../../../actions/admin/reportaction';
import {setIsModalOpen} from '../../../../actions/modalstateactions';
import {clearErrors} from '../../../../actions/erroractions';

function SelectedEngagementHeader(props) {
	const [errorMessage, setErrorMessage] = useState('');

	const dispatch = useDispatch();
	const engagementUpdateSuccessMessage = useSelector(
		(store) => store.successMessages?.updateEngagement
	);
	const [isLoading, setIsLoading] = useState(false);
	const duration = successMessageDisplayDuration;
	const engagementId = props.engagementDetails?.engagementId;

	useEffect(() => {
		const timer = setTimeout(() => {
			dispatch(setEngagementUpdateSuccessMessage(''));
		}, duration);
		return () => clearTimeout(timer);
	});

	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	const downloadEngagementValidationReport = () => {
		clearError(false);
		setIsLoading(true);
		const countryid = new URLSearchParams(location.search).get('countryid');
		const ssl = new URLSearchParams(location.search).get('ssl');
		var url =
			env.getURL('serviceUrlV2') +
			'admin/subservicelines/' +
			ssl +
			'/countries/' +
			countryid +
			'/engagements/' +
			engagementId +
			'/engagementreports?ReportType=' +
			reportType.Validation;
		var dateTime = moment(new Date()).format('MM-DD-YYYY-HH-mm-ss');
		dispatch(
			downloadReport(
				url,
				engagementId + '_' + dateTime + '.' + reportFormateType.xlsx
			)
		).finally(() => {
			setIsLoading(false);
		});
	};

	return (
		<Wrapper>
			<section
				className="mainResponsiveWrapper toastmessage"
				style={{
					display: engagementUpdateSuccessMessage.length > 0 ? 'block' : 'none'
				}}
			>
				<Toast
					variant="success"
					duration={duration}
					onClose={() => dispatch(setEngagementUpdateSuccessMessage(''))}
				>
					{engagementUpdateSuccessMessage}
				</Toast>
			</section>
			<section
				className="toastMessage"
				style={{display: errorMessage.length > 0 ? 'block' : 'none'}}
			>
				<Toast
					variant="error"
					onClose={() => {
						setErrorMessage(false);
					}}
				>
					{errorMessage}
				</Toast>
			</section>
			<section className="e-icon-wrapper mainResponsiveWrapper">
				<section className="pageheading">
					<section className="e-page-title motif-body2-default-regular">
						{labels.engagementdetails}
					</section>
					{isLoading == true ? (
						<Loader />
					) : (
						<a onClick={downloadEngagementValidationReport}>
							<span className="generatereport">
								{labels.generateValidationReport}
							</span>
						</a>
					)}
				</section>
			</section>
			<section className="desc-wrapper mainResponsiveWrapper">
				<section className="columns">
					<section className="column">
						<section className="title motif-body2-default-regular">
							<span>{labels.selectedengagements}</span>
							<span> : </span>
						</section>
						<section className="detail">
							<span className="engagementid  motif-body2-default-regular">
								{props.engagementDetails?.engagementId}
							</span>
							<EllipsesControl
								ellipsisClass="motif-body2-default-regular"
								content={props.engagementDetails?.engagementDescription}
								tooltip={props.engagementDetails?.engagementDescription}
								noOfLines={1}
							/>
						</section>
					</section>
					<section className="column">
						<section className="title motif-body2-default-regular">
							<span>{labels.workspace}</span>
							<span> : </span>
						</section>
						<section className="detail">
							<span className="engagementid motif-body2-default-regular">
								{props.engagementDetails?.workspaceId}
							</span>
							<EllipsesControl
								ellipsisClass="motif-body2-default-regular"
								content={props.engagementDetails?.workspaceDescription}
								tooltip={props.engagementDetails?.workspaceDescription}
								noOfLines={1}
							/>
						</section>
					</section>
					<section className="column">
						<section className="title motif-body2-default-regular">
							<span>{labels.client}</span>
							<span> : </span>
						</section>
						<section className="detail">
							<span className="engagementid motif-body2-default-regular">
								{props.engagementDetails?.clientCode}
							</span>
							<EllipsesControl
								ellipsisClass="motif-body2-default-regular"
								content={props.engagementDetails?.clientName}
								tooltip={props.engagementDetails?.clientName}
								noOfLines={1}
							/>
						</section>
					</section>
					<section className="column">
						<section className="title motif-body2-default-regular">
							<span>{labels.engagementcode}</span>
							<span> : </span>
						</section>
						<section className="detail">
							<span className="engagementid motif-body2-default-regular">
								{props.engagementDetails?.primaryEngagementCode}
							</span>
							<EllipsesControl
								ellipsisClass="motif-body2-default-regular"
								content={props.engagementDetails?.primaryEngagementCodeName}
								tooltip={props.engagementDetails?.primaryEngagementCodeName}
								noOfLines={1}
							/>
						</section>
					</section>
				</section>
			</section>
			<Headerbody className="engagementpageview mainResponsiveWrapper">
				<section className="userlistwrapper">
					<EngagementHeader />
					<section id="tablebodycontainer" className=" userlist-body">
						<section className="userlistholder">
							<SelectedEngagementTableRow
								editPermission={props?.editPermission}
								retryArchivePermission={props?.retryArchivePermission}
								engagementStatusesDDOptions={props?.engagementStatusesDDOptions}
								engagementRowData={props?.engagementDetails}
								setErrorMessage={setErrorMessage}
							/>
						</section>
					</section>
				</section>
			</Headerbody>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	overflow: visible;
	background: var(--neutrals-bg-gradient1);
	padding-top: var(--spacing-xx-large);

	.userlistwrapper {
		.userlist-header {
			.userlistitem {
				white-space: nowrap;
			}
		}
		.userlistitem {
			&.status {
				.react-select__menu-list {
					max-height: var(--px-160);
				}
			}
		}
		.tablebodycontainer {
			background: var(--neutrals-00white);
		}
	}

	.toastmessage {
		* {
			font-size: var(--px-14);
		}
	}

	//pagination

	.pagerholder {
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--px-24) 0;
	}

	.engagement-paging {
		justify-content: flex-end;
		padding: var(--px-10) 0;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
	}

	.e-icon-wrapper {
		.pageheading {
			display: flex;
			padding-bottom: var(--px-16);
			justify-content: space-between;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			a {
				.generatereport {
					font-size: var(--px-14);
					font-weight: 400;
					cursor: pointer;
					color: var(--blue-600);
				}
				&:hover {
					text-decoration: none;
				}
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
				margin-right: auto;
			}
		}
	}
	.desc-wrapper {
		padding-bottom: var(--spacing-x-large);
		.column {
			float: left;
			width: 25%;
			display: inline-flex;

			.title {
				margin-right: var(--px-10);
				display: inline-flex;
			}
			.detail {
				width: 65%;
				display: inline-flex;

				.engagementid {
					margin-right: var(--px-5);
					white-space: nowrap;
				}
			}
		}
	}
	/* Stops the float property from affecting content after the columns */
	.columns:after {
		content: '';
		display: table;
		clear: both;
	}

	.searches-wrapper {
		display: grid;
		grid-template-columns: repeat(5, auto) repeat(1, auto);
		grid-gap: 20px;
		padding-bottom: var(--spacing-x-large);

		> * {
			align-self: end;
		}

		.searchlink {
			display: flex;
			padding-bottom: var(--spacing-x-large);
		}

		.e-country-dd {
			border-bottom: solid var(--px-1);

			* {
				border: none !important;
			}

			.react-select__control {
				min-height: auto;

				.react-select__input {
					padding-top: 0 !important;
				}
			}

			.react-select__single-value {
				padding-top: var(--px-2);
			}
		}

		.e-search-btn {
			width: var(--px-100);
			font-size: var(--px-14);
		}

		.e-clearsearch-btn {
			color: var(--blue-600);
			font-weight: bold;
			font-size: var(--px-12);
			cursor: pointer;
			align-self: end;
			line-height: var(--px-40);
			margin-left: var(--px-20);

			&:hover {
				text-decoration: none;
			}
		}
	}
`;

export default SelectedEngagementHeader;
